var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPullUps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 147,
    viewBox: "0 0 270 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 119C77.6995 119 58 99.3005 58 75C58 50.6995 77.6995 31 102 31C126.301 31 146 50.6995 146 75C146 99.3005 126.301 119 102 119Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 143C93.6995 143 74 123.301 74 99C74 74.6995 93.6995 55 118 55C142.301 55 162 74.6995 162 99C162 123.301 142.301 143 118 143Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156 106C129.49 106 108 84.5097 108 58C108 31.4903 129.49 10 156 10C182.51 10 204 31.4903 204 58C204 84.5097 182.51 106 156 106Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153 138C126.49 138 105 116.51 105 90C105 63.4903 126.49 42 153 42C179.51 42 201 63.4903 201 90C201 116.51 179.51 138 153 138Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118 97C93.6995 97 74 77.3005 74 53C74 28.6995 93.6995 9 118 9C142.301 9 162 28.6995 162 53C162 77.3005 142.301 97 118 97Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 270 52)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 42 143)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 3 57)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 80 0)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 207 0)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 214 142)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9736)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 22,
    width: 104,
    height: 104,
    rx: 52,
    fill: "#F7BB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 173L122 169V123H142V169L148 173",
    stroke: "#24284E",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 99V127H142V99",
    stroke: "#24284E",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 99V127H138V99",
    stroke: "#24284E",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 57L107.348 77.2155C107.765 83.4735 110.683 89.3001 115.445 93.3818V93.3818C119.675 97.0072 125.062 99 130.633 99H133.367C138.938 99 144.325 97.0072 148.555 93.3818V93.3818C153.317 89.3001 156.235 83.4735 156.652 77.2155L158 57",
    stroke: "#24284E",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 77,
    r: 12,
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 57H172",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 57L92 191",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 57L172 191",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 38V46",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 42L132 38L136 42",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22L42.5 30.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M221 28.5L240 20.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 98.5L245 104",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 109.5L38 104",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9736"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 22,
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPullUps);
export default __webpack_public_path__ + "static/media/pull-ups.1535f1eb8666846b7362eeb9e129f511.svg";
export { ForwardRef as ReactComponent };